import { jsx } from 'react/jsx-runtime';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Fallback } from '../../../patched-avatar/Avatar.mjs';
import { useAvatarContext } from '../../context.mjs';
import { getAvatarBackground } from '../../utils/color.mjs';
import { avatarFallback, avatarFallbackBackground } from './fallback.vanilla.mjs';

const AvatarFallback = forwardRef(
  ({
    className: classNameFromProps,
    color: colorFromProps,
    style: styleFromProps,
    ...props
  }, forwardedRef) => {
    const { colorScheme } = useAvatarContext("Avatar.Fallback");
    const className = classNames(avatarFallback, classNameFromProps);
    const styles = Object.assign(
      {},
      assignInlineVars({
        [avatarFallbackBackground]: colorFromProps !== void 0 ? getAvatarBackground({ color: colorFromProps, colorScheme }) : null
      }),
      styleFromProps
    );
    return /* @__PURE__ */ jsx(
      Fallback,
      {
        "data-scope": "avatar",
        "data-part": "fallback",
        className,
        style: styles,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
AvatarFallback.displayName = "Avatar.Fallback";

export { AvatarFallback };
//# sourceMappingURL=Fallback.mjs.map
